export default function playListMapper(playlists) {
  let mappedPlaylist = {};

  Object.keys(playlists).map((key) => {
    let songs = [];
    let playlist = {};
    Object.keys(playlists[key]).forEach((itemKey) => {
      if (typeof playlists[key][itemKey] === "object") {
        songs.push(playlists[key][itemKey]);
      } else {
        playlist[itemKey] = playlists[key][itemKey];
      }
    });
    playlist["songs"] = songs;
    mappedPlaylist[playlist.playlist_name] = playlist;
  });
  return mappedPlaylist;
}
